import React from "react";
import { Div } from "atomize";
import { graphql } from "gatsby";

import Header from "../components/common/Header";

import Layout from "../components/common/layout";
import SEO from "../components/seo";
import Footer from "../components/common/Footer";
import ReviewModule from "../components/common/ReviewModule";
import SalesHero from "../components/increasesales/SalesHero";
import SalesQuestion from "../components/increasesales/SalesQuestion";
import SalesCategory from "../components/increasesales/SalesCategory";
import SalesCaseStudy from "../components/increasesales/SalesCaseStudy";
import SalesNewProduct from "../components/increasesales/SalesNewProduct";
import SalesMarketing from "../components/increasesales/SalesMarketing";
import SolutionsLearnMore from "../components/common/SolutionsLearnMore";
import SolutionsFooter from "../components/common/SolutionsFooter";

const IncreaseSales = ({ data }) => {
  const content = JSON.parse(data.contentfulJson.json.json);
  return (
    <Layout>
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <SEO
        seo={data.contentfulJson.seo}
        url="https://trend.io/increase-sales"
      />
      <SalesHero
        content={content.hero}
        form={data.contentfulGlobalConfig.increaseSalesForm1.increaseSalesForm1}
      />
      <SalesQuestion content={content.salesQuestion} />
      <Div d={{ xs: "none", md: "block" }}>
        <SalesCategory content={content.salesCategory} />
      </Div>
      <SalesCaseStudy content={content.salesCaseStudy} />
      <SalesNewProduct content={content.newProduct} />
      <Div m={{ t: "6rem" }}>
        <ReviewModule content={content.reviewModule} />
      </Div>
      <SalesMarketing content={content.marketing} />
      <Div m={{ t: "10.875rem" }}>
        <SolutionsLearnMore
          content={content.LearnMoreContent}
          form={
            data.contentfulGlobalConfig.increaseSalesForm2.increaseSalesForm2
          }
        />
      </Div>
      <Div m={{ t: "10.875rem" }}>
        <SolutionsFooter content={content.footerContent} />
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export const query = graphql`
  query SolutionPage6 {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulJson(contentful_id: { eq: "6CJzr3h12Z8rx5QV3yj0LC" }) {
      json {
        json
      }
      seo {
        ...SeoFragment
      }
    }

    contentfulGlobalConfig {
      increaseSalesForm1 {
        increaseSalesForm1
      }
    }

    contentfulGlobalConfig {
      increaseSalesForm2 {
        increaseSalesForm2
      }
    }
  }
`;

export default IncreaseSales;
